<template>
    <div>
      <v-card elevation="" rounded="lg" class="mb-3" flat>
        <v-card-text class="pa-2">
          <v-btn-toggle
            v-model="activeTab"
            mandatory
            variant="flat"
            color="primary"
            class="button-toggle"
            density="compact"
            divided
          >
            <v-btn value="medicationcategory" size="small" class="text-primary">
              <v-icon icon="mdi-medication-outline" size="18" class="mr-1"></v-icon>
              Medication Category
            </v-btn>
            <v-btn value="medicationClass" size="small" class="text-primary">
              <v-icon icon="mdi-format-list-bulleted" size="18" class="mr-1"></v-icon>
              Medication Class
            </v-btn>
               <v-btn value="medication" size="small" class="text-primary">
              <v-icon icon="mdi-pill" size="18" class="mr-1"></v-icon>
              Medication
            </v-btn>
            <v-btn value="settings" size="small" class="text-primary">
              <v-icon icon="mdi-cog" size="18" class="mr-1"></v-icon>
              Settings
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
      </v-card>
  
      <v-window v-model="activeTab">
        <v-window-item value="medicationcategory">
            <MedicationCategoryCard ref="medicationCategory" />
        </v-window-item>
        <v-window-item value="medication">
            <MedicationMain ref="medicationCard" />
        </v-window-item>
        <v-window-item value="medicationClass">
          <MedicationSubCategoryCard ref="medicationClassCard" />
        </v-window-item>
        <v-window-item value="settings">
          <SettingsCard ref="settingsCard" />
        </v-window-item>
      </v-window>
    </div>
  </template>
  
  <script>
  import MedicationMain from "@/components/DrugLibrary/Cards/MedicationMain.vue";
  import MedicationSubCategoryCard from "@/components/DrugLibrary/Cards/MedicationSubCategoryCard.vue";
  import SettingsCard from "@/components/Medication/Cards/SettingsCard.vue";
  import MedicationCategoryCard from "@/components/DrugLibrary/Cards/MedicationCategoryCard.vue";
  export default {
    name: "MedicationPage",
    components: { MedicationMain, MedicationSubCategoryCard, SettingsCard, MedicationCategoryCard },
    data() {
      return {
        activeTab: "medicationcategory",
      };
    },
    watch: {
      activeTab(newVal) {
        if (
          newVal === "medicationcategory" &&
          this.$refs.medicationCategory?.onTabActivated
        ) {
          this.$refs.medicationCategory.onTabActivated();
        }
        if (newVal === "medication" && this.$refs.medicationCard?.onTabActivated) {
          this.$refs.medicationCard.onTabActivated();
        }
        if (newVal === "medicationClass" && this.$refs.medicationClassCard?.onTabActivated) {
          this.$refs.medicationClassCard.onTabActivated();
        }
        if (newVal === "settings" && this.$refs.settingsCard?.onTabActivated) {
          this.$refs.settingsCard.onTabActivated();
        }
      },
    },
  };
  </script>
  <style scoped>
    .button-toggle :deep(.v-btn) {
      min-width: 140px;
      font-weight: 500;
      text-transform: capitalize;
      font-size: 0.875rem;
    }
    
    .button-toggle :deep(.v-btn--active) {
      color: white !important;
    }
    
    .button-toggle :deep(.v-btn--active .v-icon) {
      color: white !important;
    }
    </style>